import React from 'react';
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Select from 'react-select';
const CboDivision = ({ selectedValue, onChange, disabled, grupo, empresa, seccion, className }) => {


  const [divisiones, setDivisiones] = useState([])

  ///const location = useLocation();    



  useEffect(() => {


    // var { unaSeccion } = location.state || {};
    console.log('Sección de divisiones:', seccion);


    var json3;
    var jsons3;
    var url3;
    let consulta = new Object();

    consulta.grupo = grupo;
    consulta.empresa = empresa;
    consulta.seccion = seccion;


    if (seccion) {
      jsons3 = JSON.stringify(consulta);


      var options3 = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'

        },
        mode: 'cors',
        credential: 'include',
        body: jsons3,

      };

      url3 = `${process.env.REACT_APP_API_URL}/div/alldivisiones`;

      console.log("Refresca divisiones");

      fetch(url3, options3)
        .then(response => response.json())
        .then(data => {

          json3 = data;
          console.log("Divisiones:", data)
          setDivisiones(json3.data);

          if (json3.data.length > 0) {
            var primerId;
            if (selectedValue) {
              primerId = selectedValue;
            }
            else {
              primerId = json3.data[0].Div_IdDiv;
            }
            const eventoSimulado = {
              target: {
                value: primerId
              }
            };
            onChange(eventoSimulado);
          }



        })
    }

  }, [seccion]);

  const opcionesDivisiones = [
    { value: 0, label: 'todas las divisiones' },

    ...divisiones.map((unolista) => ({
      value: unolista.Div_IdDiv,
      label: unolista.Div_Nombre
    }))
  ];

  const divisionSeleccionado =
    opcionesDivisiones.find(op => op.value === selectedValue);


  return (



    /* <select className={`form-control form-select mb-3 ${className} `} value={selectedValue} onChange={onChange} disabled={disabled}  >
              <option value="">-- Seleccionar división --</option>
              {divisiones.map((unolista, index) => (
                <option key={index + '_opt'} value={unolista.Div_IdDiv}  >{unolista.Div_Nombre}</option>
    
    
              )
              )
              }
    
            </select> */








    <div className={"col-lg-offset-0 col-lg-2 col-xs-12 col-sm-4"}>
      <div className="form-group">
        <label className="l">
          División
        </label>

        <Select
          classNamePrefix="miSelect"
          isSearchable={false}
          options={opcionesDivisiones}
          value={divisionSeleccionado}
          onChange={(opcion) =>
            onChange({
              target: {
                value: opcion.value || 0
              }
            })
          }
          isDisabled={disabled}
        />

      </div>
    </div>
  );
};

export default CboDivision;






